import { useTranslation } from 'react-i18next';

import { CycleAnalytics } from '@treams/treams-analytics';
import { useLocalize } from '@treams/treams-hooks';
import { DownloadIcon } from '@treams/treams-icons';
import { Button } from '@treams/treams-ui';

import { exportCycleAnalyticsToExcel } from './cycleExcelExport';

// Same control as the metric details download (AnalyticsMetricDetailsExport).
// The data is already in memory, so there is no progress modal.
export function CycleExcelExportButton({
	cycleAnalytics,
	activeGroupIDs,
	year,
}: {
	cycleAnalytics: CycleAnalytics;
	activeGroupIDs: Set<string>;
	year: number;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const onClick = async () => {
		const title = localize(cycleAnalytics.cycleTemplate.title).text ?? '';

		try {
			await exportCycleAnalyticsToExcel({
				cycleAnalytics,
				activeGroupIDs,
				t,
				localize,
				fileName: `${title} - ${year}.xlsx`,
			});
		} catch {
			alert(t('analytics.export.error'));
		}
	};

	return (
		<Button
			type="secondary"
			icon={<DownloadIcon />}
			title={t('analytics.metric.downloadButton')}
			onClick={onClick}
			flexShrink={0}
		/>
	);
}
